export const PURPOSE = {
  LEGAL_TERMS: 'LEGAL_TERMS',
  LEGAL_PRIVACY_POLICY: 'LEGAL_PRIVACY_POLICY',
  LEGAL_DATA_PRIVACY_POLICY: 'LEGAL_DATA_PRIVACY_POLICY',
  LEGAL_COMMUNITY_GUIDELINES: 'LEGAL_COMMUNITY_GUIDELINES',
  LEGAL_EXECEDGE_TERMS: 'LEGAL_EXECEDGE_TERMS',
  LEGAL_COOKIE_ANALYTICS: 'LEGAL_COOKIE_ANALYTICS',
  PROFILE_SHARING_MODE: 'PROFILE_SHARING_MODE',
  FUTURE_JOB_MATCHING: 'FUTURE_JOB_MATCHING',
  DEIDENTIFIED_PROFILE_USE: 'DEIDENTIFIED_PROFILE_USE',
  EMAIL_MARKETING: 'EMAIL_MARKETING',
  EMAIL_EXECEDGE: 'EMAIL_EXECEDGE',
  EMAIL_JOB_OPPORTUNITIES: 'EMAIL_JOB_OPPORTUNITIES',
  EMAIL_APPLICATION_STATUS: 'EMAIL_APPLICATION_STATUS',
  WHATSAPP_MARKETING: 'WHATSAPP_MARKETING',
  JOB_APPLICATION_PROCESSING: 'JOB_APPLICATION_PROCESSING',
  CLIENT_PROFILE_SHARING: 'CLIENT_PROFILE_SHARING',
  PRIVACY_DECISION: 'PRIVACY_DECISION',
  DATA_ERASURE: 'DATA_ERASURE',
  DATA_EXPORT: 'DATA_EXPORT',
  DATA_CORRECTION: 'DATA_CORRECTION',
  GRIEVANCE: 'GRIEVANCE',
};

export const ACTION = {
  GRANTED: 'GRANTED',
  DECLINED: 'DECLINED',
  WITHDRAWN: 'WITHDRAWN',
  ACCEPTED: 'ACCEPTED',
  NOTICE_ACKNOWLEDGED: 'NOTICE_ACKNOWLEDGED',
  ALLOWED: 'ALLOWED',
  DENIED: 'DENIED',
  DISCLOSED: 'DISCLOSED',
  ERASURE_REQUESTED: 'ERASURE_REQUESTED',
  ERASURE_COMPLETED: 'ERASURE_COMPLETED',
  DATA_EXPORT_REQUESTED: 'DATA_EXPORT_REQUESTED',
  DATA_EXPORTED: 'DATA_EXPORTED',
  DATA_CORRECTION_REQUESTED: 'DATA_CORRECTION_REQUESTED',
  DATA_CORRECTED: 'DATA_CORRECTED',
  GRIEVANCE_RAISED: 'GRIEVANCE_RAISED',
};

export const DOCUMENT_KEY = {
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  DATA_PRIVACY_POLICY: 'DATA_PRIVACY_POLICY',
  COMMUNITY_GUIDELINES: 'COMMUNITY_GUIDELINES',
  EXECEDGE_TERMS: 'EXECEDGE_TERMS',
  COOKIE_AND_ANALYTICS_NOTICE: 'COOKIE_AND_ANALYTICS_NOTICE',
  APPLICATION_PRIVACY_NOTICE: 'APPLICATION_PRIVACY_NOTICE',
  PROFILE_SHARING_CONSENT: 'PROFILE_SHARING_CONSENT',
  FUTURE_OPPORTUNITY_CONSENT: 'FUTURE_OPPORTUNITY_CONSENT',
  DEIDENTIFIED_PROFILE_CONSENT: 'DEIDENTIFIED_PROFILE_CONSENT',
  EMAIL_MARKETING_CONSENT: 'EMAIL_MARKETING_CONSENT',
  EMAIL_EXECEDGE_CONSENT: 'EMAIL_EXECEDGE_CONSENT',
  EMAIL_JOB_OPPORTUNITIES_CONSENT: 'EMAIL_JOB_OPPORTUNITIES_CONSENT',
  EMAIL_APPLICATION_STATUS_CONSENT: 'EMAIL_APPLICATION_STATUS_CONSENT',
  WHATSAPP_MARKETING_CONSENT: 'WHATSAPP_MARKETING_CONSENT',
};

export const DOCUMENT_TYPE = {
  POLICY: 'POLICY',
  TERMS: 'TERMS',
  NOTICE: 'NOTICE',
  CONSENT_TEXT: 'CONSENT_TEXT',
};

export const DOCUMENT_SCOPE = {
  PLATFORM: 'PLATFORM',
  APPLICATION: 'APPLICATION',
  PROFILE_SHARING: 'PROFILE_SHARING',
  FUTURE_JOBS: 'FUTURE_JOBS',
  DEIDENTIFIED_PROFILE: 'DEIDENTIFIED_PROFILE',
  EMAIL_MARKETING: 'EMAIL_MARKETING',
  EMAIL_EXECEDGE: 'EMAIL_EXECEDGE',
  EMAIL_JOB_OPPORTUNITIES: 'EMAIL_JOB_OPPORTUNITIES',
  EMAIL_APPLICATION_STATUS: 'EMAIL_APPLICATION_STATUS',
  WHATSAPP_MARKETING: 'WHATSAPP_MARKETING',
};

export const PROFILE_SHARING_VALUE = {
  AUTO_SHARE: 'AUTO_SHARE',
  PER_SUBMISSION: 'PER_SUBMISSION',
};

export const EMPTY_PRIVACY_CHOICES = {
  profileSharingMode: '',
  futureJobMatching: null,
  deidentifiedProfileUse: null,
  emailExecEdge: null,
  emailJobOpportunities: null,
  emailApplicationStatus: null,
};

export const DOCUMENT_KEY_OPTIONS = [
  { value: DOCUMENT_KEY.PRIVACY_POLICY, label: 'Privacy Notice', documentType: DOCUMENT_TYPE.POLICY, scope: DOCUMENT_SCOPE.PLATFORM },
  { value: DOCUMENT_KEY.TERMS_AND_CONDITIONS, label: 'Platform Terms of Use', documentType: DOCUMENT_TYPE.TERMS, scope: DOCUMENT_SCOPE.PLATFORM },
  { value: DOCUMENT_KEY.DATA_PRIVACY_POLICY, label: 'Internal Data Protection Policy', documentType: DOCUMENT_TYPE.POLICY, scope: DOCUMENT_SCOPE.PLATFORM },
  { value: DOCUMENT_KEY.EXECEDGE_TERMS, label: 'ExecEdge Program Terms and Conditions', documentType: DOCUMENT_TYPE.TERMS, scope: DOCUMENT_SCOPE.PLATFORM },
  { value: DOCUMENT_KEY.COOKIE_AND_ANALYTICS_NOTICE, label: 'Cookie and Analytics Notice', documentType: DOCUMENT_TYPE.NOTICE, scope: DOCUMENT_SCOPE.PLATFORM },
  { value: DOCUMENT_KEY.APPLICATION_PRIVACY_NOTICE, label: 'Application Privacy Notice', documentType: DOCUMENT_TYPE.NOTICE, scope: DOCUMENT_SCOPE.APPLICATION },
  { value: DOCUMENT_KEY.PROFILE_SHARING_CONSENT, label: 'Profile Sharing Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.PROFILE_SHARING },
  { value: DOCUMENT_KEY.FUTURE_OPPORTUNITY_CONSENT, label: 'Future Opportunity Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.FUTURE_JOBS },
  { value: DOCUMENT_KEY.DEIDENTIFIED_PROFILE_CONSENT, label: 'De-identified Profile Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.DEIDENTIFIED_PROFILE },
  { value: DOCUMENT_KEY.EMAIL_EXECEDGE_CONSENT, label: 'ExecEdge Email Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.EMAIL_EXECEDGE },
  { value: DOCUMENT_KEY.EMAIL_JOB_OPPORTUNITIES_CONSENT, label: 'Job Email Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.EMAIL_JOB_OPPORTUNITIES },
  { value: DOCUMENT_KEY.EMAIL_APPLICATION_STATUS_CONSENT, label: 'Application Email Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.EMAIL_APPLICATION_STATUS },
  { value: DOCUMENT_KEY.EMAIL_MARKETING_CONSENT, label: 'Email Marketing Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.EMAIL_MARKETING },
  { value: DOCUMENT_KEY.WHATSAPP_MARKETING_CONSENT, label: 'WhatsApp Marketing Consent', documentType: DOCUMENT_TYPE.CONSENT_TEXT, scope: DOCUMENT_SCOPE.WHATSAPP_MARKETING },
];

export const PURPOSE_LABELS = {
  LEGAL_TERMS: 'Terms & Conditions',
  LEGAL_PRIVACY_POLICY: 'Privacy Notice',
  LEGAL_DATA_PRIVACY_POLICY: 'Internal Data Protection Policy',
  LEGAL_COMMUNITY_GUIDELINES: 'Community Guidelines',
  LEGAL_EXECEDGE_TERMS: 'ExecEdge Program Terms and Conditions',
  LEGAL_COOKIE_ANALYTICS: 'Cookie and Analytics Notice',
  JOB_APPLICATION_PROCESSING: 'Job application',
  PROFILE_SHARING_MODE: 'Profile sharing',
  CLIENT_PROFILE_SHARING: 'Client profile sharing',
  FUTURE_JOB_MATCHING: 'Future job matches',
  DEIDENTIFIED_PROFILE_USE: 'De-identified profile',
  EMAIL_MARKETING: 'Email updates',
  EMAIL_EXECEDGE: 'ExecEdge emails',
  EMAIL_JOB_OPPORTUNITIES: 'Job emails',
  EMAIL_APPLICATION_STATUS: 'Application emails',
  WHATSAPP_MARKETING: 'WhatsApp updates',
  PRIVACY_DECISION: 'Employer share',
  DATA_ERASURE: 'Deletion request',
  DATA_EXPORT: 'Data download',
  DATA_CORRECTION: 'Correct my data',
  GRIEVANCE: 'Grievance',
};

export const ACTION_LABELS = {
  GRANTED: 'Turned on',
  DECLINED: 'Left off',
  WITHDRAWN: 'Turned off',
  ACCEPTED: 'Accepted',
  NOTICE_ACKNOWLEDGED: 'Notice acknowledged',
  ALLOWED: 'Allowed',
  DENIED: 'Denied',
  DISCLOSED: 'Shared',
  RECONFIRMED: 'Re-accepted',
  ERASURE_REQUESTED: 'Requested',
  ERASURE_COMPLETED: 'Completed',
  DATA_EXPORT_REQUESTED: 'Requested',
  DATA_EXPORTED: 'PDF',
  DATA_CORRECTION_REQUESTED: 'Requested',
  DATA_CORRECTED: 'Saved',
  GRIEVANCE_RAISED: 'Sent',
};

export const CHANNEL_LABELS = {
  APPLICATION: 'Job application',
  LOGIN: 'Login',
  PRIVACY_DASHBOARD: 'Privacy settings',
  EMAIL: 'Email',
  WHATSAPP: 'WhatsApp',
  PUBLIC_LINK: 'Public link',
  ADMIN: 'Admin',
  SYSTEM: 'System',
};

export const DOCUMENT_STATUS_LABELS = {
  DRAFT: 'Draft',
  PUBLISHED: 'Live',
  RETIRED: 'Retired',
};

export const PROFILE_SHARING_OPTIONS = [
  {
    value: PROFILE_SHARING_VALUE.AUTO_SHARE,
    title: 'Share automatically',
    description: 'HireVeda may share your profile with employers for roles you apply to.',
  },
  {
    value: PROFILE_SHARING_VALUE.PER_SUBMISSION,
    title: 'Ask before sharing',
    description: 'HireVeda shares your profile with HireVeda clients only after you say yes.',
  },
];

export const DATA_USE_PERMISSIONS = [
  {
    key: 'futureJobMatching',
    purpose: PURPOSE.FUTURE_JOB_MATCHING,
    label: 'Future job matches',
    description: 'HireVeda may consider your profile for roles you did not apply to.',
    documentKey: DOCUMENT_KEY.FUTURE_OPPORTUNITY_CONSENT,
  },
  {
    key: 'deidentifiedProfileUse',
    purpose: PURPOSE.DEIDENTIFIED_PROFILE_USE,
    label: 'De-identified profile',
    description: 'HireVeda may use your profile with your name and contact details removed.',
    documentKey: DOCUMENT_KEY.DEIDENTIFIED_PROFILE_CONSENT,
  },
];

export const COMMUNICATION_PERMISSIONS = [
  {
    key: 'emailExecEdge',
    purpose: PURPOSE.EMAIL_EXECEDGE,
    label: 'ExecEdge emails',
    description: 'HireVeda emails about ExecEdge programs and business services.',
    documentKey: DOCUMENT_KEY.EMAIL_EXECEDGE_CONSENT,
  },
  {
    key: 'emailJobOpportunities',
    purpose: PURPOSE.EMAIL_JOB_OPPORTUNITIES,
    label: 'Job emails',
    description: 'HireVeda emails about new roles and opportunities.',
    documentKey: DOCUMENT_KEY.EMAIL_JOB_OPPORTUNITIES_CONSENT,
  },
  {
    key: 'emailApplicationStatus',
    purpose: PURPOSE.EMAIL_APPLICATION_STATUS,
    label: 'Application emails',
    description: 'HireVeda emails about the status of jobs you applied to.',
    documentKey: DOCUMENT_KEY.EMAIL_APPLICATION_STATUS_CONSENT,
  },
];

export const OPTIONAL_PERMISSIONS = [...DATA_USE_PERMISSIONS, ...COMMUNICATION_PERMISSIONS];

export const VIEW_DATA_SECTIONS = [
  { key: 'account', label: 'Account' },
  { key: 'candidate', label: 'Candidate profile' },
  { key: 'experience', label: 'Experience and education' },
  { key: 'applications', label: 'Applications' },
  { key: 'privacy', label: 'Privacy choices' },
  { key: 'activity', label: 'Activity' },
];

export const EMPTY_VIEW_INCLUDE = Object.fromEntries(VIEW_DATA_SECTIONS.map((item) => [item.key, true]));

export function sharingModeLabel(value) {
  if (value === PROFILE_SHARING_VALUE.AUTO_SHARE) return 'Share automatically';
  if (value === PROFILE_SHARING_VALUE.PER_SUBMISSION) return 'Ask before sharing';
  return 'Not set';
}

export function formatPrivacyDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

export function formatLegalDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(d);
}

export function permissionAllowed(permission) {
  return Boolean(permission?.allowed);
}

export function permissionSetupState(permission) {
  if (!permission || permission.status === 'NOT_FOUND') return 'unset';
  if (permission.allowed || permission.status === 'GRANTED') return 'yes';
  return 'no';
}

export function permissionSetupLabel(permission) {
  const state = permissionSetupState(permission);
  if (state === 'unset') return 'Not set up';
  if (state === 'yes') return 'Yes';
  return 'No';
}

export function choicesFromPrivacyMe(data) {
  const choice = (permission) => {
    const state = permissionSetupState(permission);
    if (state === 'unset') return null;
    return state === 'yes';
  };
  return {
    profileSharingMode: data?.permissions?.profileSharingMode?.value || '',
    futureJobMatching: choice(data?.permissions?.futureJobMatching),
    deidentifiedProfileUse: choice(data?.permissions?.deidentifiedProfileUse),
    emailExecEdge: choice(data?.permissions?.emailExecEdge),
    emailJobOpportunities: choice(data?.permissions?.emailJobOpportunities),
    emailApplicationStatus: choice(data?.permissions?.emailApplicationStatus),
  };
}

export function accountDataPath(action) {
  return `/settings/privacy/account/${action}`;
}

export const PRIVACY_SECTION_IDS = ['data-privacy', 'rights', 'legal', 'activity'];

export const PRIVACY_SECTION_ALIASES = {
  sharing: 'data-privacy',
  permissions: 'data-privacy',
  account: 'rights',
  'account-and-data': 'rights',
};

export function resolvePrivacySection(raw) {
  const mapped = PRIVACY_SECTION_ALIASES[raw] || raw;
  return PRIVACY_SECTION_IDS.includes(mapped) ? mapped : 'data-privacy';
}

export function profilePrivacyPath(section) {
  const resolved = resolvePrivacySection(section);
  return `/candidate/profile?view=privacy&section=${encodeURIComponent(resolved)}`;
}

export function activityTitle(event) {
  const purpose = PURPOSE_LABELS[event?.purpose] || event?.purpose || 'Activity';
  if (event?.purpose === PURPOSE.PROFILE_SHARING_MODE && event?.value) {
    return `${purpose} · ${sharingModeLabel(event.value)}`;
  }
  const action = ACTION_LABELS[event?.action] || String(event?.action || '').replace(/_/g, ' ').toLowerCase();
  return `${purpose} · ${action}`;
}

export function activityDetail(event) {
  const action = ACTION_LABELS[event?.action] || String(event?.action || '').replace(/_/g, ' ').toLowerCase();
  const value = event?.value ? String(event.value).replace(/_/g, ' ').toLowerCase() : '';
  const channel = CHANNEL_LABELS[event?.channel] || event?.channel;
  return [action, value, channel].filter(Boolean).join(' · ');
}
